__turbopack_context__.v({
  "menuItem": "_dJwva_menuItem",
  "menuItemChevron": "_dJwva_menuItemChevron",
  "menuItemHeading": "_dJwva_menuItemHeading",
  "menuItemLabel": "_dJwva_menuItemLabel",
  "subtleActive": "_dJwva_subtleActive",
});
